'use client';

import { c as _c } from "react/compiler-runtime";
import { supporterDetailsQuery } from '../queries.ts';
import { getSupporterEmail, getSupporterFullName, getSupporterInitials, getSupporterPreferredName } from '../utils/name-format.ts';
import { useSupporterQuery } from './base.ts';
export enum NameFormats {
  preferred = 'preferred',
  full = 'full',
  initials = 'initials',
  email = 'email',
}
export const useSupporterDetails = () => {
  return useSupporterQuery(supporterDetailsQuery);
};
export const useSupporterName = format => {
  const $ = _c(8);
  const {
    data: details
  } = useSupporterDetails();
  switch (format) {
    case NameFormats.full:
      {
        let t0;
        if ($[0] !== details) {
          t0 = getSupporterFullName(details);
          $[0] = details;
          $[1] = t0;
        } else {
          t0 = $[1];
        }
        return t0;
      }
    case NameFormats.initials:
      {
        let t0;
        if ($[2] !== details) {
          t0 = getSupporterInitials(details);
          $[2] = details;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      }
    case NameFormats.email:
      {
        let t0;
        if ($[4] !== details) {
          t0 = getSupporterEmail(details);
          $[4] = details;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        return t0;
      }
    case NameFormats.preferred:
    default:
      {
        let t0;
        if ($[6] !== details) {
          t0 = getSupporterPreferredName(details);
          $[6] = details;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        return t0;
      }
  }
};